const f = {
  color: {
    background: "#ffffffff"
  },
  border: {
    default: {
      width: "1px",
      color: "#dfe6ebff"
    },
    clickable: {
      color: "#c8d3deff",
      hover: {
        color: "#abb9c7ff"
      }
    }
  }
};
export {
  f as card
};
